import { useEffect, useState } from "react";
import moment from "moment";
import {
  Card,
  Pagination,
  Row,
  Typography,
} from "antd";
import {
} from "@ant-design/icons";
import { useParams } from "react-router-dom";
import * as _ from 'lodash';
import { useProjects } from "../../hooks/useProjects";

import Meta from "antd/lib/card/Meta";

export function ClientView() {
  const {
    fetchProjects,
    projects,
    total,
  } = useProjects();

  const currentRoute = useParams();
  const [page, setPage] = useState<number>(Number(currentRoute.page));
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState<string>("title");
  const [search, setSearch] = useState<string>("");
  const [filterPhase, setFilterPhase] = useState<string[]>([]);

  const statuses = [
    { id: 1, title: 'Em andamento' },
    { id: 2, title: 'On hold' },
    { id: 3, title: 'Finalizado' },
  ];

  const fetchProjectDebounce = _.debounce(() => {
    return fetchProjects(page, order, orderBy, search, filterPhase);
  }, 500);

  useEffect(() => {
    if (page && order && orderBy) {
      fetchProjectDebounce();
    }
  }, [page, order, orderBy, filterPhase]);

  return (
    <>
      <Row style={{ justifyContent: 'flex-start', }}>
        {
          projects.map((project) => (
            <Card
              key={project.id}
              hoverable
              style={{ width: '24%', margin: 2 }}
              cover={
                project.image
                  // eslint-disable-next-line jsx-a11y/img-redundant-alt
                  ? <img alt={`image of ${project.title}`} src={project.image} style={{ backgroundColor: '#d9d9d9', width: '100%', height: 180, objectFit: 'cover' }} />
                  : <div style={{ backgroundColor: '#d9d9d9', width: '100%', height: 180 }}></div>
              }
              onChange={() => null}
            >
              <Meta title={project.title} description={project.description}/>
              <Row style={{ flexDirection: 'column', marginBottom: 20, marginTop: 10,  padding: 0 }}>
                <Typography.Text style={{ fontSize: 12 }}>
                  Total Tarefas: { project?.total_tasks || 0 }
                </Typography.Text>
                <Typography.Text style={{ fontSize: 12 }}>
                  Total Tarefas concluídas: { project?.total_tasks_finished || 0 }
                </Typography.Text>
                <Typography.Text style={{ fontSize: 12 }}>
                  Previsão de conclusão: {moment.utc(project.result_finish_date).format('DD/MM/YYYY')}
                </Typography.Text>
                <Typography.Text style={{ fontSize: 12 }}>
                  Status: { statuses.find(st => st.id === project.status_id)?.title }
                </Typography.Text>
              </Row>
            </Card>
          ))
        }
      </Row>

      <Row style={{ justifyContent: 'flex-end', marginTop: 10 }}>
        <Pagination
          defaultCurrent={page}
          defaultPageSize={12}
          total={total}
          onChange={(pageAux) => setPage(pageAux)}
        />
      </Row>
    </>
  );
}
